import React, {
  Suspense,
  ReactNode,
  ComponentType,
  LazyExoticComponent,
} from "react";

interface PageWrapperProps {
  children: ReactNode;
  state?: any;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children }) => {
  console.log("children", children);

  // Check if children is a lazy component (LazyExoticComponent)
  const isLazyComponent =
    React.isValidElement(children) &&
    typeof children.type === "object" &&
    "$$typeof" in children.type;

  return isLazyComponent ? (
    <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
  ) : (
    <>{children}</>
  );
};

export default PageWrapper;
